export const OPPORTUNITY_TYPE_LABELS: Record<string, string> = {
  RFI: 'Request for Information',
  RFP: 'Request for Proposals',
  RFR: 'Request for Responses',
  RFQ: 'Request for Quotes or Qualifications',
  IFB: 'Invitation for Bids',
  ITB: 'Invitation to Bid',
  ITQ: 'Invitation to Quote',
  RFB: 'Request for Bids',
  NOI: 'Notice of Intent',
  NOFA: 'Notice of Funding Availability',
  NOFO: 'Notice of Funding Opportunity',
};

export const describeOpportunityType = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  const descriptions = value.split('/').map((code) => OPPORTUNITY_TYPE_LABELS[code] ?? code);
  return descriptions.join(' / ');
};

